<div
  class="chosen-container chosen-container-multi"
  (click)="focusResult()"
  (mouseleave)="unfocusResult()"
  [attr.aria-owns]="htmlId + '_listBox'"
  [attr.aria-expanded]="resultExpanded && !fieldDisabled"
  [class.field-disabled]="fieldDisabled"
>
  <ul class="chosen-choices" *ngIf="multiple">
    <li class="search-choice" *ngFor="let elem of assureArray(chosenElement)">
      <span class="search-choice-text">{{ elem?.content?.name }}</span>
      <button class="search-choice-close" (click)="removeElem(elem)">
        <span class="nodisplay">{{ 'commons:chosen.remove_element' | translate }}</span>
      </button>
    </li>
    <li class="search-field" role="search" [class.contain-value]="!empty()">
      <input
        [id]="htmlId"
        [formControl]="filter"
        type="text"
        (change)="processFilterCollection()"
        (focus)="focusResult()"
        (keydown)="onKeyDown($event)"
        (keyup)="onKeyUp()"
        [attr.title]="getPlaceHolder()"
        [placeholder]="getPlaceHolder()"
        aria-autocomplete="off"
        autocomplete="off"
        [ngClass]="{ backup: !!elem?.content?.backup }"
      />
    </li>
  </ul>
  <div class="chosen-choices" *ngIf="!multiple">
    <span class="search-field single-filed" [class.contain-value]="!empty()">
      <input
        [id]="htmlId"
        type="text"
        role="combobox"
        [attr.multiple]="multiple"
        [formControl]="filter"
        #singleInput
        aria-haspopup="true"
        aria-autocomplete="list"
        (keydown)="onKeyDown($event)"
        (keyup)="onKeyUp()"
        aria-autocomplete="off"
        autocomplete="off"
        [attr.aria-controls]="htmlId + '_listBox'"
        [attr.aria-activedescendant]="htmlId + '_' + currentIndex"
        (change)="processFilterCollection()"
        (focus)="focusResult()"
        [attr.title]="getPlaceHolder()"
        [placeholder]="getPlaceHolder()"
      />
      <div title="{{ 'commons:chosen.remove_element_single' | translate }}" *ngIf="!empty()">
        <button type="button" [hidden]="empty()" class="single-choice-close" (click)="removeElemSingle(chosenElement, singleInput)">
          <span class="nodisplay">{{ 'commons:chosen.remove_element_single' | translate }}</span>
        </button>
      </div>
    </span>
  </div>
  <div class="chosen-drop" [class.result-expanded]="resultExpanded && !fieldDisabled">
    <ul class="chosen-results" role="listbox" [id]="htmlId + '_listBox'">
      <ng-container *ngFor="let elem of elements; let i = index">
        <li
          role="option"
          class="active-result"
          *ngIf="elem.displayed"
          [id]="htmlId + '_' + i"
          [attr.aria-hidden]="!elem.displayed"
          [attr.aria-selected]="elem.chosen"
          [ngClass]="{ 'result-chosen': elem.chosen, selected: elem.selected, backup: !!elem.content.backup }"
          (click)="selectElem(elem)"
        >
          {{ elem.content.name }}
        </li>
      </ng-container>
    </ul>
  </div>
</div>
